import { useTranslation } from "react-i18next";
import type { ReviewItem } from "./reviewSeed";

interface Props {
  items: readonly ReviewItem[];
  activeSubjectCount: number;
}

function statsFor(
  items: readonly ReviewItem[],
  activeSubjectCount: number,
): { pending: number; processed: number; subjects: number; handoffs: number } {
  let pending = 0;
  let processed = 0;
  let handoffs = 0;
  for (const item of items) {
    if (item.stage === "uploaded" || item.stage === "in_review") {
      pending++;
    } else if (
      item.stage === "approved" ||
      item.stage === "rejected" ||
      item.stage === "promoted"
    ) {
      processed++;
      if (item.stage === "approved") handoffs++;
    }
  }
  return { pending, processed, subjects: activeSubjectCount, handoffs };
}

export function WorkflowStats({ items, activeSubjectCount }: Props): JSX.Element {
  const { t } = useTranslation();
  const stats = statsFor(items, activeSubjectCount);

  const cells: Array<{ key: keyof typeof stats; labelKey: string }> = [
    { key: "pending", labelKey: "dashboard.reviewConsole.stats.pending" },
    { key: "processed", labelKey: "dashboard.reviewConsole.stats.processed" },
    { key: "subjects", labelKey: "dashboard.reviewConsole.stats.subjects" },
    { key: "handoffs", labelKey: "dashboard.reviewConsole.stats.handoffs" },
  ];

  return (
    <section className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {cells.map((c) => (
        <div
          key={c.key}
          className="rounded-xl border border-slate-200 bg-white px-4 py-3"
        >
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
            {t(c.labelKey)}
          </p>
          <p className="mt-1 text-2xl font-semibold text-white">{stats[c.key]}</p>
        </div>
      ))}
    </section>
  );
}
